import GlobalPaths from './Library/Global/Paths'
import AppsPaths from './Library/Apps/Paths'
import CloudInfraPaths from './Library/Cloudinfra/Paths'
import AntdPaths from './Library/Antd/Paths'
import MGMTPaths from './Library/MGMT/Paths'
import SysPaths from './Library/Sys/Paths'

const $ = Symbol('icon-store')
const tos = (x: any) => String(x).toLowerCase().trim()

class ICO {
  constructor(o: any) {
    this[ $ ] = new Map
    // @ts-ignore
    Object.entries(o).forEach(a => this.add(...a))
  }

  add(aliases: string, path: string) {
    for (let alias of aliases.split(',')) this.set(alias, path)
    return this
  }

  /* istanbul ignore next */
  has(a: string) {
    return this[ $ ].set(tos(a))
  }

  get(a: string) {
    return this[ $ ].get(tos(a)) || null
  }

  set(a: string, b: string) {
    return this[ $ ].set(tos(a), b)
  }
}

export const paths = {
  ...GlobalPaths,
  ...AppsPaths,
  ...CloudInfraPaths,
  ...AntdPaths,
  ...MGMTPaths,
  ...SysPaths,
}
export default new ICO(paths)


